package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.buttons.*

@Page
@Composable
fun ButtonPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/button.md", mapOf("title" to listOf("Button"), "description" to listOf("Displays a button or a component that looks like a button.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonDemo = FC<Props> {
    Button { +"Button" }
}"""){ 
 ButtonDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Button
""", lang= "kotlin", highlight= "")
            CodeBlock("""Button {
    variant = "outline"
    +"Outline"
}
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("primary")
 }) {
                org.jetbrains.compose.web.dom.Text("Primary")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonDemo = FC<Props> {
    Button { +"Button" }
}"""){ 
 ButtonDemo {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("secondary")
 }) {
                org.jetbrains.compose.web.dom.Text("Secondary")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonSecondary = FC<Props> {
    Button {
        variant = "secondary"
        +"Secondary"
    }
}"""){ 
 ButtonSecondary {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("destructive")
 }) {
                org.jetbrains.compose.web.dom.Text("Destructive")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonDestructive = FC<Props> {
    Button {
        variant = "destructive"
        +"Destructive"
    }
}"""){ 
 ButtonDestructive {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("outline")
 }) {
                org.jetbrains.compose.web.dom.Text("Outline")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonOutline = FC<Props> {
    Button {
        variant = "outline"
        +"Outline"
    }
}"""){ 
 ButtonOutline {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("ghost")
 }) {
                org.jetbrains.compose.web.dom.Text("Ghost")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonGhost = FC<Props> {
    Button {
        variant = "ghost"
        +"Ghost"
    }
}"""){ 
 ButtonGhost {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("link")
 }) {
                org.jetbrains.compose.web.dom.Text("Link")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Button

val ButtonLink = FC<Props> {
    Button {
        variant = "link"
        +"Link "
    }
}"""){ 
 ButtonLink {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("icon")
 }) {
                org.jetbrains.compose.web.dom.Text("Icon")
            }
            ComponentPreview("""import lucide_react.ChevronRight
import react.FC
import react.Props
import shadcn.ui.components.Button
import web.cssom.ClassName

val ButtonIcon = FC<Props> {
    Button {
        variant = "outline"
        size = "icon"
        ChevronRight { className = ClassName("h-4 w-4") }
    }
}"""){ 
 ButtonIcon {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("with-icon")
 }) {
                org.jetbrains.compose.web.dom.Text("With Icon")
            }
            ComponentPreview("""import lucide_react.Mail
import react.FC
import react.Props
import shadcn.ui.components.Button
import web.cssom.ClassName

val ButtonWithIcon = FC<Props> {
    Button {
        Mail {
            className = ClassName("mr-2 h-4 w-4")
        }
        +"Login with Email"
    }
}"""){ 
 ButtonWithIcon {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("loading")
 }) {
                org.jetbrains.compose.web.dom.Text("Loading")
            }
            ComponentPreview("""import lucide_react.Loader2
import react.FC
import react.Props
import shadcn.ui.components.Button
import web.cssom.ClassName

val ButtonLoading= FC<Props> {
    Button {
        disabled = true
        Loader2 {
            className = ClassName("mr-2 h-4 w-4 animate-spin")
        }
        +"Please wait"
    }
}"""){ 
 ButtonLoading {} 
 }
        }
    }
}
